// ./utils/api-endpoints/teammemberEndpoints.ts

export const teammemberEndpoints = {
  getEmployeesByFilter: '/api/Employee/Filter',
  getTeamMemberById: '/api/Employee/GetEmployeeForTeam',
  getEmployeeDetailsById: '/api/Employee/GetById',

  getDepartmentList: '/api/Department/Filter',
  getDesignationList: '/api/Designation/GetAll',

  getCountryList: 'api/Country/GetAll',

  getSkillList: 'api/SkillSet/Filter',

  getUserRightList: 'api/UserAccessRight/GetUserRights',

  employeeInsert: 'api/Employee/Insert',

  employeeUpdate: 'api/Employee/Update',

  getEmployeeUserRightsById: 'api/UserAccessRight/GetUserRights',
  getCurrentUserRightsById: 'api/UserAccessRight/GetMyRights',

  employeeHeirarchy: 'api/EmployeeHierarchy/Filter',
  getUnAssignedEmployee: 'api/EmployeeHierarchy/NotMapped',

  employeeHierarchyInsert: 'api/EmployeeHierarchy/Insert',

  employeeHierarchyDelete: 'api/EmployeeHierarchy/Delete',

  employeeFileAdd: 'api/EmployeeFile/Upload',

  getTimesheet: '/api/WorkReport/Filter',

  employeeHierarchyReplace: 'api/EmployeeHierarchy/Replace',

  getDepartments: 'api/Department/GetAll',

  getEmployeeTarget: 'api/EmployeeTarget/GetByEmployeeId',

  getMyEmployeeTarget: 'api/EmployeeTarget/GetMyEmployee',

  addEmployeeTarget: 'api/EmployeeTarget/Insert',

  resetEmployeePassword: 'api/Employee/ResetPassword',

  getTaskCompletionByEmployee: '/api/Dashboard/GetTaskCompletionByEmployee',
  getTaskCompletionByDepartment: '/api/Dashboard/GetTaskCompletionByDepartment',
};
